import { render, staticRenderFns } from "./lgsala.vue?vue&type=template&id=47bff7fd&"
import script from "./lgsala.vue?vue&type=script&lang=js&"
export * from "./lgsala.vue?vue&type=script&lang=js&"
import style0 from "./lgsala.vue?vue&type=style&index=0&id=47bff7fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports